import { HEADER_HEIGHT, Shared } from "./shared";

const DATA_CACHE = {};

export class ScrollRevealVideo {

	constructor(node, index) {
		this.init(node, index);
	}

	init(node, index) {
		const selector = node.getAttribute('scroll-reveal-video') || '.scroll-reveal-video__wrapper';
		const wrapper = node.querySelector(selector);
		if (!wrapper) {
			throw ('ScrollRevealVideo.error missing wrapper');
		}
		const content = wrapper.firstElementChild;
		if (!content) {
			throw ('ScrollRevealVideo.error missing content');
		}
		const image = content.querySelector('img');
		if (!image) {
			throw ('ScrollRevealVideo.error missing image');
		}
		const src = node.getAttribute('data-src');
		if (!src) {
			throw ('ScrollRevealVideo.error missing data-src');
		}
		let frames = node.getAttribute('data-frames');
		if (!frames) {
			throw ('ScrollRevealVideo.error missing data-frames');
		}
		frames = parseInt(frames);
		const extension = '.' + src.split('.').pop();
		let base = src.replace(extension, '');
		let digits = base.match(/\d+$/);
		if (!digits) {
			throw ('ScrollRevealVideo.error invalid data-src');
		}
		digits = digits[0];
		base = base.replace(digits, '');
		digits = digits.length;
		const canvas = document.createElement('canvas');
		const context = canvas.getContext('2d');
		image.parentNode.replaceChild(canvas, image);
		// console.log('ScrollRevealVideo.init', base, digits, extension, src, frames, content);
		this.node = node;
		this.index = index;
		this.wrapper = wrapper;
		this.content = content;
		this.image = image;
		this.canvas = canvas;
		this.context = context;
		this.src = src;
		this.base = base;
		this.digits = digits;
		this.extension = extension;
		this.frames = frames;
		this.datas = this.preloadFrames();
		this.viewRect = { width: 0, height: 0, top: 0, right: 0, bottom: 0, left: 0 };
		this.onResize();
		this.addListeners();
		// console.log('ScrollRevealVideo.init', node, wrapper, content);
	}

	preloadFrames() {
		return new Array(this.frames).fill(0).map((_, i) => {
			const frame = i + 1;
			const src = this.base + this.padded(frame, this.digits) + this.extension;
			let data = DATA_CACHE[src];
			if (!data) {
				const image = new Image();
				data = { frame, image, loading: true };
				image.onload = () => {
					data.loading = false;
					image.onload = null;
				};
				image.src = src;
				DATA_CACHE[src] = data;
			}
			return data;
		});
	}

	drawImage(image, type, width, height) {
		const canvas = this.canvas;
		const context = this.context;
		canvas.width = width;
		canvas.height = height;
		// context.drawImage(data.image, 0, 0, wrapper.style.width, wrapper.style.height);
		const imageRatio = image.naturalHeight / image.naturalWidth;
		const canvasRatio = height / width;
		if (type === 'cover') {
			if (imageRatio > canvasRatio) {
				const h = width * imageRatio;
				context.drawImage(image, 0, (height - h) / 2, width, h);
			} else {
				const w = width * canvasRatio / imageRatio;
				context.drawImage(image, (width - w) / 2, 0, w, height);
			}
		} else {
			if (imageRatio > canvasRatio) {
				const w = width * canvasRatio / imageRatio;
				context.drawImage(image, (width - w) / 2, 0, w, height);
			} else {
				const h = width * imageRatio;
				context.drawImage(image, 0, (height - h) / 2, width, h);
			}
		}
	}

	update() {
		const node = this.node;
		const wrapper = this.wrapper;
		const content = this.content;
		const image = this.image;
		const context = this.context;
		const datas = this.datas;
		const viewRect = this.viewRect;
		const contentRect = this.contentRect;
		const outerRect = this.outerRect;
		const frames = this.frames;
		node.style.height = contentRect.height * frames / 10 + 'px';
		const nodeRect = node.getBoundingClientRect();

		const isPositionStickySupported = Shared.isPositionStickySupported();
		if (isPositionStickySupported) {
			wrapper.style.position = 'sticky';
			wrapper.style.top = viewRect.top + 'px';
			wrapper.style.bottom = 0 + 'px';
		}
		if (nodeRect.top < viewRect.top && nodeRect.bottom > viewRect.top + contentRect.height) {
			if (!isPositionStickySupported) {
				wrapper.style.left = nodeRect.left + 'px';
				wrapper.style.width = nodeRect.width + 'px';
				wrapper.style.top = viewRect.top + 'px';
				wrapper.style.position = 'fixed';
			}
			node.classList.add('active');
		} else {
			if (!isPositionStickySupported) {
				wrapper.style.position = 'relative';
				wrapper.style.left = null;
				wrapper.style.width = null;
				if (nodeRect.bottom < viewRect.top + contentRect.height) {
					wrapper.style.top = nodeRect.height - contentRect.height + 'px';
				} else {
					wrapper.style.top = null;
				}
			}
			node.classList.remove('active');
		}

		let pow = (nodeRect.top - viewRect.top) / (nodeRect.height - contentRect.height) * -1;
		pow = Math.max(0, Math.min(1, pow));
		const frame = 1 + Math.min(frames - 1, Math.floor(frames * pow));
		const pow2 = 1 - Math.max(0, Math.abs(pow - 0.5) - 0.3) / 0.2;
		const w = (contentRect.width + (outerRect.width - contentRect.width) * pow2);
		const h = (contentRect.height + (outerRect.height - contentRect.height) * pow2);
		const x = (contentRect.width - outerRect.width) / 2 * pow2;
		const y = (contentRect.height - outerRect.height) / 2 * pow2;
		const data = datas[frame - 1];
		content.style.width = w + 'px';
		content.style.height = h + 'px';
		content.style.transform = `translateX(${x}px) translateY(${y}px)`;
		/*
		if (this.index === 0) {
			console.log(pow, pow2, data.frame);
		}
		*/
		if (!data.loading) {
			this.drawImage(data.image, 'cover', w, h);
		}
		/*
		const src = this.base + this.padded(frame, this.digits) + this.extension;
		if (image.src !== src) {
			image.src = src;
		}
		*/
		/*
		if (this.index === 0) {
			console.log('update');
		}
		*/
		/*
		if (nodeRect.top < viewRect.top + viewRect.height / 2 && nodeRect.bottom > viewRect.top + contentRect.height) {
			node.classList.add('active');
		} else {
			node.classList.remove('active');
		}
		*/
		// console.log('ScrollRevealVideo.update', nodeRect, contentRect);
	}

	padded(value, digits) {
		const len = value.toString().length;
		return new Array(digits - len).fill(0).join('') + value;
	}

	onScroll() {
		// console.log('ScrollRevealVideo.onScroll');
		this.update();
	}

	onResize() {
		// console.log('ScrollRevealVideo.onResize');
		const content = this.content;
		content.style.width = null;
		content.style.height = null;
		content.style.transform = null;
		const contentRect = content.getBoundingClientRect();
		const viewRect = { width: window.innerWidth, height: window.innerHeight - HEADER_HEIGHT, top: HEADER_HEIGHT, right: window.innerWidth, bottom: window.innerHeight, left: 0 };
		const dy = viewRect.height > contentRect.height ? (viewRect.height - contentRect.height) / 2 : 0;
		const gutter = Math.max(0, Math.min(30, (viewRect.width - 768) / 672 * 30));
		viewRect.top += dy;
		viewRect.bottom -= dy;
		viewRect.height = viewRect.bottom - viewRect.top;
		this.viewRect = viewRect;
		this.contentRect = contentRect;
		this.outerRect = { width: window.innerWidth - gutter * 2, height: window.innerHeight - HEADER_HEIGHT - gutter * 2, top: HEADER_HEIGHT + gutter, right: window.innerWidth - gutter, bottom: window.innerHeight - gutter, left: gutter }
		this.update();
	}

	addListeners() {
		this.onScroll = this.onScroll.bind(this);
		this.onResize = this.onResize.bind(this);
		document.addEventListener('scroll', this.onScroll);
		window.addEventListener('resize', this.onResize);
	}

	removeListeners() {
		document.removeEventListener('scroll', this.onScroll);
		window.removeEventListener('resize', this.onResize);
	}

	destroy() {
		this.removeListeners();
		// console.log('ScrollRevealVideo.destroy');
	}

	static init() {
		this.items = Array.prototype.slice.call(document.querySelectorAll('[scroll-reveal-video]')).map((x, i) => new ScrollRevealVideo(x, i));
	}

	static destroy() {
		if (this.items) {
			while (this.items.length) {
				this.items.pop().destroy();
			}
		}
	}

}
